import { apiSlice } from "../api/apiSlice";

export const scheduleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    // -----------------------------------------------------------------------
    // Feeder Groups
    // -----------------------------------------------------------------------
    getFeederGroups: builder.query({
      query: () => "/dsm/feeder-groups/",
      providesTags: ["feeder_groups"],
    }),
    addFeederGroup: builder.mutation({
      query: (request) => ({
        url: "/dsm/feeder-groups/",
        method: "POST",
        body: request.body,
      }),
      invalidatesTags: ["feeder_groups"],
    }),
    updateFeederGroup: builder.mutation({
      query: (request) => ({
        url: `/dsm/feeder-groups/${request.id}/`,
        method: "PATCH",
        body: request.body,
      }),
      invalidatesTags: ["feeder_groups"],
    }),
    deleteFeederGroup: builder.mutation({
      query: ({ id }) => ({
        url: `/dsm/feeder-groups/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["feeder_groups"],
    }),

    // -----------------------------------------------------------------------
    // Configuration Profiles
    // -----------------------------------------------------------------------
    getConfigurations: builder.query({
      query: () => "/dsm/settings/",
      providesTags: ["configurations"],
    }),
    addConfiguration: builder.mutation({
      query: (request) => ({
        url: "/dsm/settings/",
        method: "POST",
        body: request.body,
      }),
      invalidatesTags: ["configurations"],
    }),
    updateConfiguration: builder.mutation({
      query: (request) => ({
        url: `/dsm/settings/${request.id}/`,
        method: "PATCH",
        body: request.body,
      }),
      invalidatesTags: ["configurations"],
    }),
    deleteConfiguration: builder.mutation({
      query: ({ id }) => ({
        url: `/dsm/settings/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["configurations"],
    }),

    // -----------------------------------------------------------------------
    // Load Shifting Schedules
    // -----------------------------------------------------------------------
    getScheduleLSList: builder.query({
      query: () => "/dsm/schedule-load-shift/",
      providesTags: ["schedulels"],
    }),
    addScheduleLS: builder.mutation({
      query: (request) => ({
        url: "/dsm/schedule-load-shift/",
        method: "POST",
        body: request.body,
      }),
      invalidatesTags: ["schedulels"],
    }),
    updateBulkScheduleLS: builder.mutation({
      query: (request) => ({
        url: "/dsm/schedule-load-shift/bulk-update/",
        method: "PATCH",
        body: request.body,
      }),
      invalidatesTags: ["schedulels"],
    }),
    deleteScheduleLS: builder.mutation({
      query: ({ schedule_id }) => ({
        url: `/dsm/schedule-load-shift/update/${schedule_id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["schedulels"],
    }),

    // -----------------------------------------------------------------------
    // Peak Shaving Schedules
    // -----------------------------------------------------------------------
    getSchedulePSList: builder.query({
      query: () => "/dsm/schedule-peak-shave/",
      providesTags: ["scheduleps"],
    }),
    addSchedulePS: builder.mutation({
      query: (request) => ({
        url: "/dsm/schedule-peak-shave/",
        method: "POST",
        body: request.body,
      }),
      invalidatesTags: ["scheduleps"],
    }),
    updateBulkSchedulePS: builder.mutation({
      query: (request) => ({
        url: "/dsm/schedule-peak-shave/bulk-update/",
        method: "PATCH",
        body: request.body,
      }),
      invalidatesTags: ["scheduleps"],
    }),
    deleteSchedulePS: builder.mutation({
      query: ({ schedule_id }) => ({
        url: `/dsm/schedule-peak-shave/update/${schedule_id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["scheduleps"],
    }),
  }),
});

export const {
  // Feeder Groups
  useGetFeederGroupsQuery,
  useAddFeederGroupMutation,
  useUpdateFeederGroupMutation,
  useDeleteFeederGroupMutation,
  // Configurations
  useGetConfigurationsQuery,
  useAddConfigurationMutation,
  useUpdateConfigurationMutation,
  useDeleteConfigurationMutation,
  // Load Shifting
  useGetScheduleLSListQuery,
  useAddScheduleLSMutation,
  useUpdateBulkScheduleLSMutation,
  useDeleteScheduleLSMutation,
  // Peak Shaving
  useGetSchedulePSListQuery,
  useAddSchedulePSMutation,
  useUpdateBulkSchedulePSMutation,
  useDeleteSchedulePSMutation,
} = scheduleApiSlice;
